import type { SVGProps } from 'react'

/**
 * Sistem ikon.
 *
 * Antarmuka lama memuat Font Awesome 6.5 dari cdnjs — 130 kB CSS ditambah
 * berkas font, sebagai permintaan yang memblokir render, dari host pihak
 * ketiga, dan tidak tersedia sama sekali saat luring. Untuk aplikasi yang
 * dipasang sebagai PWA itu berarti ikonnya hilang justru ketika sinyal buruk.
 *
 * Di sini ikon berupa SVG sebaris: hanya jalur yang benar-benar dipakai yang
 * ikut ke dalam bundel, mewarisi warna teks induknya, dan tidak pernah gagal
 * dimuat.
 *
 * Semua ikon digambar pada kanvas 24x24 dengan sapuan 1,75 agar bobotnya
 * seragam saat ditampilkan berdampingan.
 */

const P = {
  folder: 'M4 20a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5l2 3h7a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2z',
  folderOpen: 'M4 20a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5l2 3h7a2 2 0 0 1 2 2v1M2.5 20l2.6-7.3a2 2 0 0 1 1.9-1.3h14a1 1 0 0 1 .95 1.3L19.5 20z',
  file: 'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zM14 3v5h5',
  fileText: 'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zM14 3v5h5M9 13h6M9 17h4',
  fileImage: 'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zM14 3v5h5M9.5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M18 19l-3.5-4.5-3 3.5-2-2L8 19',
  fileVideo: 'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zM14 3v5h5M10 12.5v4l4-2z',
  fileAudio: 'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zM14 3v5h5M9 17.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0M12 17.5V12l4-1v4.5M14.5 17a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0',
  fileArchive: 'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zM14 3v5h5M10 5h2M10 8h2M10 11h2M10 14h2M11 17h1v3h-2v-2z',
  fileCode: 'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zM14 3v5h5M10 18l-2-2 2-2M14 14l2 2-2 2',
  filePdf: 'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zM14 3v5h5M8.5 17v-4h1.2a1.2 1.2 0 0 1 0 2.4H8.5M13 17v-4h1a2 2 0 0 1 0 4z',
  fileSheet: 'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zM14 3v5h5M8 12h8M8 15.5h8M8 19h8M11.5 12v7',

  download: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3',
  upload: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12',
  share: 'M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8M16 6l-4-4-4 4M12 2v13',
  link: 'M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7',
  star: 'm12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.9L12 17.8 5.8 21l1.2-6.9-5-4.9 6.9-1z',
  trash: 'M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6M10 11v6M14 11v6',
  edit: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.1 2.1 0 0 1 3 3L12 15l-4 1 1-4z',
  copy: 'M20 9h-9a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1',
  move: 'M5 9l-3 3 3 3M9 5l3-3 3 3M15 19l-3 3-3-3M19 9l3 3-3 3M2 12h20M12 2v20',
  folderPlus: 'M4 20a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5l2 3h7a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2zM12 11v6M9 14h6',
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16M21 21l-4.3-4.3',
  grid: 'M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z',
  list: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
  sort: 'M3 6h11M3 12h7M3 18h4M17 8V4m0 0-3 3m3-3 3 3M17 16v4m0 0 3-3m-3 3-3-3',
  more: 'M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2',
  check: 'm4 12 6 6L20 6',
  close: 'M18 6 6 18M6 6l12 12',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  chevronRight: 'm9 18 6-6-6-6',
  chevronLeft: 'm15 18-6-6 6-6',
  chevronDown: 'm6 9 6 6 6-6',
  chevronUp: 'm18 15-6-6-6 6',
  arrowLeft: 'M19 12H5M12 19l-7-7 7-7',
  home: 'm3 10 9-7 9 7v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z M9 22V12h6v10',
  user: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8',
  users: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',
  shield: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10',
  logout: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9',
  settings: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1',
  eye: 'M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6',
  info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20M12 16v-4M12 8h.01',
  warning: 'M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0M12 9v4M12 17h.01',
  error: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20M15 9l-6 6M9 9l6 6',
  success: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20M8 12l3 3 5-6',
  clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20M12 6v6l4 2',
  lock: 'M5 11h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2M7 11V7a5 5 0 0 1 10 0v4',
  database: 'M12 8c4.4 0 8-1.3 8-3s-3.6-3-8-3-8 1.3-8 3 3.6 3 8 3M20 5v14c0 1.7-3.6 3-8 3s-8-1.3-8-3V5M20 12c0 1.7-3.6 3-8 3s-8-1.3-8-3',
  refresh: 'M21 2v6h-6M3 22v-6h6M21 8A9 9 0 0 0 5.6 5.6L3 8M3 16a9 9 0 0 0 15.4 2.4L21 16',
  inbox: 'M22 12h-6l-2 3h-4l-2-3H2M5.5 5h13a2 2 0 0 1 1.8 1.1l2.5 5.4a2 2 0 0 1 .2.9V19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6.6a2 2 0 0 1 .2-.9l2.5-5.4A2 2 0 0 1 5.5 5',
  drive: 'M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z',
  external: 'M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14 21 3',
  menu: 'M3 6h18M3 12h18M3 18h18',
  filter: 'M22 3H2l8 9.5V19l4 2v-8.5z',
  image: 'M5 21h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2M9 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4M21 15l-5-5L5 21',
} as const

export type IconName = keyof typeof P

interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  name: IconName
  /** ukuran dalam piksel; bawaan 20 */
  size?: number
  /** Label untuk pembaca layar. Wajib diisi bila ikon berdiri sendiri tanpa
   *  teks pendamping — tanpa ini, tombol berisi ikon saja tidak punya makna
   *  apa pun bagi pengguna tunanetra. */
  label?: string
}

export function Icon({ name, size = 20, label, ...rest }: IconProps) {
  const d = P[name]
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
      {...rest}
    >
      <path d={d} />
    </svg>
  )
}

/** Pilih ikon yang sesuai untuk sebuah berkas berdasarkan ekstensinya. */
export function iconForFile(ext: string | null, isDir: boolean): IconName {
  if (isDir) return 'folder'
  switch ((ext ?? '').toLowerCase()) {
    case 'pdf':
      return 'filePdf'
    case 'doc': case 'docx': case 'odt': case 'rtf':
      return 'fileText'
    case 'xls': case 'xlsx': case 'csv': case 'ods':
      return 'fileSheet'
    case 'ppt': case 'pptx': case 'odp':
      return 'fileText'
    case 'zip': case 'rar': case '7z': case 'tar': case 'gz':
      return 'fileArchive'
    case 'mp4': case 'mkv': case 'mov': case 'avi': case 'webm': case 'flv': case 'm4v':
      return 'fileVideo'
    case 'mp3': case 'wav': case 'ogg': case 'flac': case 'aac': case 'm4a':
      return 'fileAudio'
    case 'jpg': case 'jpeg': case 'png': case 'gif': case 'webp': case 'bmp':
    case 'avif': case 'heic': case 'heif': case 'hif':
    case 'svg': case 'psd': case 'tif': case 'tiff':
      return 'fileImage'
    case 'txt': case 'md': case 'log':
      return 'fileText'
    case 'js': case 'ts': case 'json': case 'html': case 'css': case 'xml':
    case 'php': case 'py': case 'sh': case 'yml': case 'yaml': case 'sql':
      return 'fileCode'
    default:
      return 'file'
  }
}
